<template>
    <div class="user_actions_main admin_main_wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="top_filters_area">
            <div class="filters_area">
                <div class="filters_sub_area">
                    <div class="places_selector">
                        <b-dropdown :text="filterAction.action" no-caret>
                            <b-dropdown-item v-on:click="onActionChosen(item)" v-for="(item, index) in availableActions"
                                             :key="index">
                                <div class="type_dropdown_item">
                                    <div class="name">{{ item.action }} ({{ item.total }})</div>
                                </div>
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <div class="filters_sub_area">
                    <div class="votes_search">
                        <b-form-input
                            v-model="search"
                            placeholder="Start typing to search"
                            class="search_profiles"
                        ></b-form-input>
                    </div>
                </div>
                <div class="filters_sub_area">
                    <div class="checkbox-filters">
                        <b-form-checkbox v-model="includeAdmins">
                            <span>Include 'by admins'</span>
                        </b-form-checkbox>
                    </div>
                    <span style="margin-left: 10px; margin-top: 4px; text-decoration: underline; cursor: pointer;"
                          @click="onRefreshClick">Refresh</span>
                </div>
            </div>
        </div>
        <b-list-group class="votes_list" @scroll="onListScrolled">
            <b-list-group-item v-for="(item, index) in items" :key="index" class="votes_item">
                <div class="votes_top">
                    <div class="action-main-info" @click="item.showDetails = !item.showDetails">
                        <div class="main-info-item by-admin" style="width: 23px;" v-if="includeAdmins"><div v-if="item.by_admin">Ⓐ</div></div>
                        <div class="main-info-item" style="width: 130px;">
                            {{ item.log_time | moment("HH:mm:ss DD.MM.YYYY ") }}
                        </div>
                        <div class="main-info-item action" style="width: 190px;">{{ item.action }}<div class="ic-filter" @click.stop="onFilterActionClick(item)"><img src="@/assets/icons/filter.svg"/></div></div>
                        <div class="main-info-item" style="width: auto">{{ item.user.email }}<div class="ic-filter" @click.stop="onFilterUserClick(item)"><img src="@/assets/icons/filter.svg"/></div></div>
                        <!--                        <div class="wrapper"><h5>#{{ item.id }} <b>{{ item.action }}</b></h5></div>-->
                        <!--                        <h5>{{ item.place.name }} |
                                                    {{ item.question ? (item.question.text + ' (' + item.question.id + ')') : '' }}</h5>
                                                <span><a :href="getQuestionManageLink(item)" target="_blank"><span
                                                    v-if="item.question && item.question.asset_id != ''">{{ item.question ? item.question.asset_id : '' }} | </span>{{ item.question ? item.question.placement : '' }}</a><a
                                                    v-if="item.gps" :href="getGeolocationGoogleMapLink(item)"
                                                    target="_blank"> ({{ item.gps.lat }}, {{ item.gps.lng }})</a></span>-->
                    </div>
                    <div v-if="item.showDetails" class="action-details">
                        <pre class="action-data">{{ JSON.stringify(item.data, null, 2) }}</pre>
                    </div>
                </div>
            </b-list-group-item>

            <infinite-loading :identifier="infinityValue" @infinite="getUserActions">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </b-list-group>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import customModalDialog from '@/components/widgets/customModalDialog';
import errorMixin from "@/mixins/errorMixin";
import adminStickyHeaderMixin from "@/mixins/adminStickyHeaderMixin";
import adminPageMixin from "@/mixins/adminPageMixin";

export default {
    mixins: [mixin, errorMixin, adminStickyHeaderMixin, adminPageMixin,],
    name: "serviceRequests",
    components: {
        InfiniteLoading,
        customModalDialog
    },
    data() {
        return {
            search: '',
            searchTimerDelay: null,
            includeAdmins: false,
            filterAction: {action: 'All actions', total: 0, default: true,},
            availableActions: [],
            customModalSettings: {},
            items: [],
            infinityValue: +new Date(),
            page: 1,
            searchTimer: null,
        }
    },
    props: ['infinity'],
    watch: {
        search(value) {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(() => {
                this.refreshItems()
            }, 300);
            this.updateSearchParams()
        },
        infinity(val) {
            this.page = 1
            this.infinityValue += 1
        },
        includeAdmins(newValue) {
            this.refreshItems()
        },
    },
    async mounted() {
        this.parseSearchParams()
        this.parseActionParams()
        this.initAdminPage()
        this.getInitialData()
    },
    methods: {
        ...mapActions({
            fetchAvailableUserActions: 'userActions/fetchAvailableUserActions',
            fetchUserActions: 'userActions/fetchUserActions',
        }),
        resetList() {
            this.page = 1;
            this.votesLoaded = false
            this.items = [];
            this.infinityValue += 1;
        },
        onRefreshClick() {
            this.resetList()
        },
        async getInitialData() {
            try {
                const response = await this.fetchAvailableUserActions()
                if (response.success) {
                    this.availableActions = response.actions
                    this.availableActions.unshift({action: 'All actions', total: 0, default: true,})
                } else {
                    this.showErrorModal()
                }
            } catch (e) {
                this.showErrorModal()
            } finally {
            }
        },
        async getUserActions(stateInf) {
            try {
                this.loadingAction = true
                let countPerPage = 100
                const response = await this.fetchUserActions({
                    page: this.page,
                    s: encodeURIComponent(this.search),
                    action: this.filterAction.default ? '' : this.filterAction.action,
                    include_admins: this.includeAdmins,
                    count_per_page: countPerPage,
                })
                if (response.success) {
                    this.page += 1;
                    if (this.items.length == 0) {
                        for (let i = 0; response.items.length > i; i++) {
                            response.items[i].showDetails = false
                        }
                        this.items = response.items;
                    } else {
                        response.items.forEach((item) => {
                            item.showDetails = false
                            this.items.push(item);
                            console.log(item)
                        })
                    }
                    if (stateInf && stateInf.loaded != undefined) {
                        if (response.items.length === countPerPage) {
                            stateInf.loaded();
                        } else {
                            stateInf.complete();
                        }
                    }
                } else {
                    this.showErrorModal()
                }
            } catch (e) {
                this.showErrorModal()
            } finally {
                this.loadingAction = false
            }
        },

        refreshItems() {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(() => {
                this.page = 1;
                this.items = [];
                this.infinityValue += 1;
            }, 450);
        },
        onActionChosen(item) {
            this.filterAction = item
            this.onActionChanged()
        },
        onActionChanged() {
            this.refreshItems()
            this.updateActionParams()
        },
        onListScrolled(element) {
            this.fixStickyHeader(element.srcElement.scrollTop)
        },
        onFilterActionClick(item) {
            this.filterAction = {action: item.action, total: 0, }
            this.onActionChanged()
        },
        onFilterUserClick(item) {
            this.search = item.user.email
        },
        parseSearchParams() {
            let search = this.$route.query.s
            if(search && search != '') {
                this.search = search
            }
        },
        updateSearchParams() {
            let query = JSON.parse(JSON.stringify(this.$route.query))
            delete query['s']
            if (this.search != '') query.s = this.search
            this.$router.push({
                path: this.$route.path, query: query
            })
        },
        parseActionParams() {
            let action = this.$route.query.action
            if(action && action != '') {
                this.filterAction = {action: action, total: 0, }
            }
        },
        updateActionParams() {
            let query = JSON.parse(JSON.stringify(this.$route.query))
            delete query['action']
            if (this.filterAction != '' && !this.filterAction.default) query.action = this.filterAction.action
            this.$router.push({
                path: this.$route.path, query: query
            })
        },
    }
}
</script>
<style>
.user_actions_main .dropdown-item {
    padding-left: 0;
    padding-right: 0;
}

.user_actions_main .dropdown .dropdown-menu.show {
    display: flex;
    flex-direction: column;
}
</style>
<style scoped>
.action-main-info {
    display: flex;
    flex-direction: row;
    gap: 5px;
    width: 100%;
    cursor: pointer;
    padding-left: 4px;
}

.action-main-info:hover {
    background: #f6e6cd;
}

.action-main-info .main-info-item {
    border-right: 1px solid #8d8d8d;
    padding-top: 4px;
    padding-bottom: 4px;
    font-weight: 600;
    display: flex;
    flex-direction: row;
}
.main-info-item.by-admin div {
    font-weight: 900;
    color: #007208;
    font-size: 16px;
}
.main-info-item.action {
    font-weight: 700;
}
.main-info-item .ic-filter {
    display: none;
    margin-left: 4px;
    height: 20px;
    width: 20px;
    border-radius: 4px;
    background: #d5d5d5;
    justify-content: center;
}
.main-info-item:hover .ic-filter {
    display: flex;
}
.ic-filter:hover  {
    background: #d59b47;
}
.ic-filter img {
    width: 10px;
    height: auto;
}

.action-main-info .main-info-item:last-child {
    border-right: none;
    flex: 1;
}

.action-details {
    border-top: 1px solid #d0d0d0;
    border-bottom: 1px solid #8d8d8d;
}
.action-data {
    font-weight: 500;
    padding-left: 30px;
    padding-top: 4px;
    margin-bottom: 0;
    padding-bottom: 4px;
}

.votes_list {
    max-height: calc(100vh - 62px);
}

.btn-group, .btn-group-vertical {
    width: 100% !important;
}

.user_actions_main .dropdown /deep/ button.btn-secondary {
    background: none !important;
    border: 0;
    display: flex;
    align-items: center;
    color: #2F2F2F;
    font-weight: 700;
    position: relative;
    padding: 5px 50px 5px 0;
    margin-left: 0;
    font-size: 16px;
    font-family: 'Nunito';
    overflow: hidden;
}

.user_actions_main .dropdown:before {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    content: " ";
    background: #3F405C;
    width: 100%;
    height: 1px;
}

.user_actions_main .dropdown:after {
    content: '';
    height: 7px;
    width: 7px;
    transform: rotate(45deg);
    right: 10px;
    top: 10px;
    position: absolute;
    border-bottom: 2px solid black;
    border-right: 2px solid black;
}

.filters_area {
    display: flex;
    flex-direction: row;
    padding-left: 10px;
    margin-bottom: 4px;
}
.filters_sub_area {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.types_selector {
    max-width: 200px;
    margin-right: 12px;
    width: 100px;
    margin-top: 4px;
}

.places_selector {
    max-width: 200px;
    margin-right: 12px;
    width: 200px;
    margin-top: 4px;
}

.type_dropdown_item {
    display: flex;
    flex-direction: column;
    white-space: pre-wrap;
    max-width: 100%;
}

.type_dropdown_item .name {
    font-size: 16px;
}

.votes_list {
    overflow: auto;
    margin-bottom: 0;
    width: 100%;
    min-width: 100%;
}

.votes_item {
    display: table;
    width: 100%;
    min-width: 100%;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    font-size: .75em

}

.votes_top {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.votes_bottom {
    width: 100%;
    flex-direction: row;
    display: flex;
    padding: 0 1em;
}

.votes_comment {
    font-weight: 500;
}

.item-data-details {

}

.attachments {
    height: 170px;
    overflow: scroll;
    display: flex;
}

.attachments img {
    max-width: 100%;
    max-height: 170px;
    cursor: pointer;
}

.delete_cross img {
    margin-top: 5px;
    position: absolute;
    top: 0;
    left: 90px;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.5);;
    border-radius: 6px;
}

.votes_bottom > div {
    width: 100%;
    padding-top: .25em;
    padding-bottom: .25em;
}

.votes_bottom h5 {
    font-weight: 700;
    font-size: 1em;
    margin-bottom: .2em;
}

.votes_bottom span {
    display: block;
}

.votes_bottom .votes_place {
    padding-right: 1em;
    position: relative;
}

.votes_bottom .votes_place:before {
    position: absolute;
    content: '';
    top: 0;
    right: 0;
    bottom: 0;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.075);
}

.votes_bottom .votes_customer {
    padding-left: 1em;
}

.votes_img img {
    width: 3.5em;
    height: 3.5em;
    transform: scale(1);
    margin: 0;
}

.gps_icon {
    width: auto;
    height: 17px;
}

.votes_body {
    display: flex;
    flex-direction: column;
    width: calc(100% - 5em);
}

.votes_body h5 {
    font-weight: 700;
    font-size: 1em;
    margin-bottom: .2em;
}

.votes_body p {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0;
}

.votes_body a {
    color: black;
    cursor: pointer;
    text-decoration: underline;
}

.vote-audio {
    margin-top: 8px;
    height: 25px;
    width: 100%;
    max-width: 400px;
    display: block;
}

.wrapper {
    display: flex;
}

.checkbox-filters {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 12px;
    line-height: 12px;
}

@media screen and (max-width: 812px) {
    .filters_area {
        flex-direction: column;
        gap: 6px;
    }

    .action-main-info {
        flex-direction: column;
        gap: 0;
        padding-left: 8px;
        padding-top: 2px;
        padding-bottom: 2px;
    }

    .action-main-info .main-info-item {
        border-right: none;
        padding-top: 2px;
        padding-bottom: 2px;
    }
    .action-main-info .main-info-item.by-admin {
        position: absolute;
        top: 4px;
        right: 4px;
    }
    .main-info-item.action {
        font-weight: 800;
    }
    .action-data {
        padding-left: 8px;
    }
    .votes_list {
        max-height: calc(100vh - 150px);
    }
}
</style>
